"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _CloseOutline = _interopRequireDefault(require("@rsuite/icon-font/lib/action/CloseOutline"));

// Generated by script, don't edit it please.
var CloseOutline = (0, _createSvgIcon["default"])({
  as: _CloseOutline["default"],
  ariaLabel: 'close outline',
  category: 'action',
  displayName: 'CloseOutline'
});
var _default = CloseOutline;
exports["default"] = _default;
module.exports = exports.default;